export default [
  {
    title: 'Товары',
    to: { name: 'product-list' },
    icon: { icon: 'tabler-box' },
  },
  // {
  //   title: 'Маркировка',
  //   to: { name: 'marking-list' },
  //   icon: { icon: 'tabler-barcode' },
  // },
  // {
  //   title: 'Организации',
  //   to: { name: 'client-list' },
  //   icon: { icon: 'tabler-users' },
  // },
  {
    title: 'Репрайсер',
    to: { name: 'repricer-list' },
    icon: { icon: 'tabler-discount' },
  },
  {
    title: 'Честный знак',
    to: { name: 'chestny-znak' },
    icon: { icon: 'chz' },         
  },
  {
    title: 'Документы',
    to: { name: 'document-list' },
    icon: { icon: 'tabler-clipboard-check' },         
  },
  {
    title: 'Заказы на производство',
    to: { name: 'production-order-list' },
    icon: { icon: 'tabler-clipboard-list' },
  },
  {
    title: 'Контрагенты',
    to: { name: 'counterparties' },
    icon: { icon: 'tabler-building' },
  },
  // --- FBS: закомментируйте блок целиком, чтобы скрыть раздел из меню ---
  // {
  //   title: 'FBS',
  //   icon: { icon: 'tabler-package' },
  //   children: [
  //     {
  //       title: 'Поставки FBS',
  //       to: { name: 'fbs-supplies' },
  //       icon: { icon: 'tabler-package' },
  //     },
  //     {
  //       title: 'Сценарии',
  //       to: { name: 'scenarios' },
  //       icon: { icon: 'tabler-route' },
  //     },
  //   ],
  // },
  // --- /FBS ---
  {
    title: 'Печать',
    icon: { icon: 'tabler-printer' },
    children: [
      {
        title: 'Принтеры',
        to: { name: 'printer' },
        icon: { icon: 'tabler-printer' },
      },
      {
        title: 'Сессии печати',
        to: { name: 'sessions' },
        icon: { icon: 'tabler-history' },
      },
      {
        title: 'Отложенные задания',
        to: { name: 'print-jobs' },
        icon: { icon: 'tabler-clock' },
      },
      {
        title: 'Папки КИЗ',
        to: { name: 'label-groups' },
        icon: { icon: 'tabler-folders' },
      },
    ],
  },
  // {
  //   title: 'Склад',
  //   icon: { icon: 'tabler-building-warehouse' },
  //   children: [
  //     {
  //       title: 'Ячейки',
  //       to: { name: 'warehouse-cells' },
  //       icon: { icon: 'tabler-grid-pattern' },
  //     },
  //     {
  //       title: 'Приёмка',
  //       to: { name: 'warehouse-intake' },
  //       icon: { icon: 'tabler-package-import' },
  //     },
  //     {
  //       title: 'Журнал',
  //       to: { name: 'warehouse-journal' },
  //       icon: { icon: 'tabler-notebook' },
  //     },
  //     {
  //       title: 'Сотрудники',
  //       to: { name: 'warehouse-staff' },
  //       icon: { icon: 'tabler-users-group' },
  //     },
  //     {
  //       title: 'Настройки',
  //       to: { name: 'warehouse-settings' },
  //       icon: { icon: 'tabler-adjustments' },
  //     },
  //   ],
  // },
  {
    title: 'Редактор этикеток',
    to: { name: 'designer' },
    icon: { icon: 'tabler-tag' },
  },
  {
    title: 'Каталог элементов',
    to: { name: 'element-catalog' },
    icon: { icon: 'tabler-icons' },
  },
  // {
  //   title: 'Поддержка',
  //   to: { name: 'support' },
  //   icon: { icon: 'tabler-headset' },
  // },
]
